import { render, staticRenderFns } from "./CustomerTopItems.vue?vue&type=template&id=a798cb62"
import script from "./CustomerTopItems.vue?vue&type=script&lang=js"
export * from "./CustomerTopItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports